<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="login-title">系统登录
	  </h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="userInput">
			<div class="captcha-row">
				<el-input v-model="loginForm.userInput" placeholder="请输入验证码"></el-input>
				  <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" />
			</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" style="width: 100%" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
	<div class="icp">
		黔ICP备2026005826号
	</div>
  </div>
</template>

<script>
import api from '../utils/api'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: process.env.NODE_ENV==='development'?'admin':'',
        password: process.env.NODE_ENV==='development'?'Bylgw2026@@2026':'',
        userInput: '',
		captchaId:''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        userInput: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      captchaUrl: '',
      loading: false
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha() {
      // 使用API获取真实验证码
      api.account.getCaptcha()
        .then(res => {
          this.captchaUrl = res.data.imageSrc
		  this.loginForm.captchaId=res.data.captchaId
        })
        .catch(() => {
          // 获取验证码失败，使用备用方案
        })
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          api.account.login(this.loginForm)
            .then(res => {
              // 登录成功，保存 token
              localStorage.setItem('token', res.data)
              if (this.$router.resetDynamicRoutes) {
                this.$router.resetDynamicRoutes()
              }
              // 获取用户信息
              return api.account.getUserInfo().then(userRes => {
              // 存储用户信息到 Vuex
              this.$store.dispatch('login', userRes.data)
              this.$router.replace('/home/dashboard')
            })
            })
           
            .catch(() => {
              // 登录失败，错误信息已在响应拦截器中处理
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
	.icp{
		text-align: center;
		padding: 20px 0 10px 0;
		color: #fff;
	}
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  position: relative;
  overflow: hidden;
  flex-direction: column;
}

/* 背景装饰 */
.login-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: move 20s linear infinite;
}

@keyframes move {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.login-card {
  width: 560px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1;
  transition: all 0.3s ease;
}

.login-card:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
}

.login-title {
  text-align: center;
  margin-bottom: 32px;
  color: #303133;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 表单样式 */
.el-form {
  margin-top: 16px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item__label {
  font-weight: 500;
  color: #303133;
}

.el-input {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.el-input__inner {
  border-radius: 8px;
  height: 44px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.el-input__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/* 验证码样式 */
.captcha-img {
  cursor: pointer;
  width: 130px;
  height: 48px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.captcha-img:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.captcha-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.captcha-row .el-input {
  flex: 1;
  min-width: 0;
}

/* 登录按钮样式 */
.el-button {
  border-radius: 8px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.el-button--primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .login-card {
    width: 90%;
    max-width: 400px;
    padding: 24px;
  }
  
  .login-title {
    font-size: 20px;
    margin-bottom: 24px;
  }

  .captcha-row {
    flex-direction: column;
    gap: 8px;
  }

  .captcha-row .el-input {
    width: 100%;
  }

  .captcha-img {
    width: 100%;
    height: 44px;
    align-self: stretch;
  }
}
</style>
